export const GET_ABSENCE_REASON = 'GET_ABSENCE_REASON'
export const GET_CURRENT_PROGRESS = 'GET_CURRENT_PROGRESS'
export const GET_FILTER_DISCIPLINES = 'GET_FILTER_DISCIPLINES'
export const GET_FILTER_STUDY_GROUPS = 'GET_FILTER_STUDY_GROUPS'
export const RESET_ABSENCE_REASON = 'RESET_ABSENCE_REASON'
export const RESET_PROGRESS = 'RESET_PROGRESS'
export const RESET_STATE = 'RESET_STATE'
